import { Zap } from 'lucide-react'
import { Link, useLocation } from 'react-router'
import { StaticSiteSwitcher } from '@/components/layout/breadcrumbs/static-site/static-site-switcher'
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip'
import { useCompanyPath } from '@/lib/hooks'

const StaticSitesIconBreadcrumbItem = () => {
  const { getCompanyPath } = useCompanyPath()
  return (
    <BreadcrumbItem>
      <Link to={getCompanyPath({ pathname: '/static-sites' })}>
        <Tooltip delayDuration={1000}>
          <BreadcrumbPage className="cursor-pointer p-2 flex items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground">
            <TooltipTrigger>
              <BreadcrumbLink asChild>
                <div className="cursor-pointer">
                  <Zap className="size-3.5" />
                  <span className="sr-only">Static sites</span>
                </div>
              </BreadcrumbLink>
            </TooltipTrigger>
          </BreadcrumbPage>
          <TooltipContent sideOffset={8}>
            <span>Static sites</span>
          </TooltipContent>
        </Tooltip>
      </Link>
    </BreadcrumbItem>
  )
}

export const StaticSiteBreadcrumbs = () => {
  const { pathname } = useLocation()

  return (
    <>
      {pathname === '/static-sites' ? (
        <BreadcrumbItem>
          <BreadcrumbPage className="flex items-center gap-2 px-2">
            <Zap className="size-3.5" />
            <span className="font-medium">Static sites</span>
          </BreadcrumbPage>
        </BreadcrumbItem>
      ) : null}
      {pathname === '/static-sites/create' ? (
        <>
          <StaticSitesIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="px-2 font-medium">
              Create static site
            </BreadcrumbPage>
          </BreadcrumbItem>
        </>
      ) : null}
      {pathname.startsWith('/static-site/') ? (
        <>
          <StaticSitesIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <StaticSiteSwitcher />
        </>
      ) : null}
    </>
  )
}
